import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  open() {
    window.open(this.data.get("url"), "_blank");
  }
}
